import { render, staticRenderFns } from "./OrderListItems.vue?vue&type=template&id=705bff5e&scoped=true&"
import script from "./OrderListItems.vue?vue&type=script&lang=js&"
export * from "./OrderListItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderListItems.vue?vue&type=style&index=0&id=705bff5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705bff5e",
  null
  
)

export default component.exports